import Cookies from 'js-cookie';
import { useCallback, useState } from 'react';

export default function useCookie(
  name: string,
  defaultValue: any,
  globalOptions?: any
) {
  const [value, setValue] = useState(() => {
    const cookie = Cookies.get(name);
    if (cookie) return cookie;
    // Cookies.set(name, defaultValue, globalOptions)
    return defaultValue;
  });

  const updateCookie = useCallback(
    (newValue: any, options: any) => {
      Cookies.set(name, newValue, options);
      setValue(newValue);
    },
    [name]
  );

  const deleteCookie = useCallback(
    (options: any) => {
      Cookies.remove(name, options);
      setValue(null);
    },
    [name]
  );

  return [value, updateCookie, deleteCookie];
}
